import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogsComponent } from './catalogs/catalogs.component';
import { CategoriesComponent } from './categories/categories.component';
import { ProductsComponent } from './products/products.component';
import { ProductLinkComponent } from './product-link/product-link.component';
import { SharedPipeModule } from '../pipes/shared-pipe-module';

@NgModule({
  imports: [
    CommonModule,
    SharedPipeModule
  ],
  declarations: [
    CatalogsComponent,
    CategoriesComponent,
    ProductsComponent,
    ProductLinkComponent
  ],
  providers: []
})
export class CatalogsFormationsModule { }
